module.exports = __webpack_public_path__ + "img/caigou.56f3c576.jpg";